'use client';

import { observer } from 'mobx-react-lite';
import { fontSizes } from '@instamenu/ui-vanilla-extract';
import { Item, useCheckoutContext } from '@instamenu/context-checkout';
import { Text } from '@instamenu/ui-system-next';

const LOW_STOCK_THRESHOLD = 10;

export type ItemStockStatusProps = {
  item: Item;
};

export const ItemStockStatus = observer(({ item }: ItemStockStatusProps) => {
  const checkout = useCheckoutContext();
  if (!checkout || !item.count || item.count > LOW_STOCK_THRESHOLD) return null;

  return (
    <Text variant="error" wordBreak css={{ fontSize: fontSizes.small }} maxLines={2}>
      Only {item.count} left in stock!
    </Text>
  );
});
